// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_3aIOK"};